// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__a8r0p"};